<div class="container-fluid">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <luv-tooltip></luv-tooltip>
</div>